export default "__VITE_ASSET__BW6q2llh__"